import * as React from 'react'
import { MdLocalGasStation } from 'react-icons/md'
import clsx from 'clsx'

export default function MarkerIcon({ type, onClick, className, ...props }) {
	return (
		<button
			className={clsx(
				className,
				'relative z-[1] grid size-[1em] cursor-pointer place-content-center rounded-full border-2 border-current bg-[var(--color)] p-[.8em] text-white shadow',
				'transition-all hover:!bg-white hover:text-[var(--color)]',
			)}
			onClick={onClick}
			aria-label={type.name}
			style={{
				'--color': type.color,
			}}
			{...props}
		>
			<MdLocalGasStation />
		</button>
	)
}
